<template>
  <div class="container_block_button">
    <transition
        name="showAnimat"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
    >
    <div class="footer__block__img" v-if="isVisibilityButton" @click.stop="buttonAction">
      <p class="footer__block">{{  button }}</p>
    </div>

    <div class="footer__market_open_block" v-if="!isVisibilityButton">
      <p class="footer__market_open_p">{{ button }}</p>
      <a class="footer__market_open_line"></a>
      <div class="footer__block_market_icon">
        <a class="footer__block_market_icon"
            v-for="item in MarketItems"
            :key="item.id"
            :href="item.url"
           v-tooltip.top="{content: `${item.name}`, class: 'tooltip-arrows'}"
        >
          <img
              class="footer__market_icon scale"
              :src='item.image'
              :alt="item.name"
          >
        </a>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MarketButton",
  data: () => ({
    button: ''
  }),
  watch: {
    '$route' (to, from) {
      this.$store.dispatch('buttonAction', true)
    }
  },
  methods: {
    buttonAction(){
      if(this.isVisibilityButton === true) {
        this.$store.dispatch('buttonAction', false)
      }
    },
    buttonUpdate() {
      this.button = this.marketplaces.btn_text
    }
  },
  computed: {
    ...mapGetters(['marketplaces','MarketItems']),
    isVisibilityButton() {
      return this.$store.state.button.isCloseButton
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchMarketplaces')
    await this.$store.dispatch('fetchLand')
    this.$nextTick(this.buttonUpdate)
    }
}
</script>
